import { render, staticRenderFns } from "./VacancyStatVisitors.vue?vue&type=template&id=4facfa84&"
import script from "./VacancyStatVisitors.vue?vue&type=script&lang=js&"
export * from "./VacancyStatVisitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports